module.exports = "img/flags/PH.f787e5e.png";